/*
 *
 *  * Copyright (c) [hoarfroster-frontend] 2026. All Rights Reserved.
 *  *
 *  * Last Modified on May 29, 2026 by hoarfroster
 *
 */

import { usePreferences } from '@/contexts/preferences-context';
import I18N from '@utils/i18n.base';

export default function Footer({ className = 'mt-4' }: { className?: string }) {
    const { preferences } = usePreferences();
    if (preferences.hideFooter) return;

    return (
        <div
            className={`bg-theme-content-bg mx-auto flex min-h-18 w-full px-8 py-4 text-center text-sm font-medium ${className}`}
        >
            <div className="flex-1 space-y-0.5">
                <p className="registration">
                    <a href="https://beian.miit.gov.cn/">粤ICP备2024227184号</a>
                    <span className="px-2">|</span>
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44010602012596">
                        粤公网安备44010602012596号
                    </a>
                </p>
                <p className="copyright">
                    <span>{I18N.app.copyright}</span>
                </p>
            </div>
        </div>
    );
}
